
Vue.component("barchart", {
	extends: VueChartJs.Bar,
	props: ['data','options'],
	mounted() {
		this.renderChart(this.data,this.options);
	},
	methods : {
	},
    watch: {
        data: function() {
            this.$data._chart.update();
            this.renderChart(this.data,this.options);
        }
    }

});
